import React from 'react';
import PropTypes from 'prop-types';
import BaseButton from '../UI/BaseButton';
import TranslatedContent from '../Translations/TranslatedContent';

const PatientFormFooterActions = ({
  isInlineEdit,
  isReadOnlyForm,
  patientCancelButtonVariant,
  onCancel,
  patientCancelButtonTranslation,
  isSubmitDisabled,
  cancelButtonClassName,
  submitButtonClassName,
  patientConfirmButtonTranslation,
  patientSubmitButtonTranslation
}) => (
  <>
    {!isInlineEdit && (
      <BaseButton
        id="btn-cancel"
        className={cancelButtonClassName}
        onClick={onCancel}
        color={patientCancelButtonVariant}
        size="large"
      >
        <TranslatedContent contentArray={[patientCancelButtonTranslation]} />
      </BaseButton>
    )}
    {!isReadOnlyForm && (
      <BaseButton
        id="btn-submit"
        className={submitButtonClassName}
        disabled={isSubmitDisabled}
        type="submit"
        color="secondary"
        size="large"
      >
        <TranslatedContent
          contentArray={[isInlineEdit ? patientConfirmButtonTranslation : patientSubmitButtonTranslation]}
        />
      </BaseButton>
    )}
  </>
);

PatientFormFooterActions.propTypes = {
  isInlineEdit: PropTypes.bool,
  isReadOnlyForm: PropTypes.bool.isRequired,
  patientCancelButtonVariant: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  patientCancelButtonTranslation: PropTypes.object,
  isSubmitDisabled: PropTypes.bool.isRequired,
  cancelButtonClassName: PropTypes.string,
  submitButtonClassName: PropTypes.string,
  patientConfirmButtonTranslation: PropTypes.object,
  patientSubmitButtonTranslation: PropTypes.object
};

export default PatientFormFooterActions;
